import { Tooltip } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import OutgoingMailIcon from '@mui/icons-material/MarkEmailUnread';
import ClearIcon from '@mui/icons-material/ClearAll';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import { CustomButton, HorizontalForm } from '../../../common';

const DebtDetailActionsBar = ({
  onSelectAllContracts,
  onExportExcel,
  onExportPdf,
  onSendNotifications,
  onClearSelection,
  isExporting = false,
  excelLoading = false,
  pdfLoading = false,
  disableExports = false,
  disableSend = false,
  disableClear = false,
  disableSelectAll = false,
  isSelectAllLoading = false,
  sendTooltip = 'Enviar recordatorio a los suscriptores seleccionados',
}) => {
  const exportsDisabled = disableExports || isExporting;
  const disableExcel = exportsDisabled || excelLoading;
  const disablePdf = exportsDisabled || pdfLoading;

  return (
    <HorizontalForm justifyContent="flex-end" sx={{ my: 0, py: 2 }}>
      <Tooltip title="Seleccionar todos los contratos filtrados">
        <span>
          <CustomButton
            variant="info"
            startIcon={<SelectAllIcon />}
            onClick={onSelectAllContracts}
            disabled={disableSelectAll}
            isLoading={isSelectAllLoading}
            sx={{ mr: 2 }}
          >
            Seleccionar todos
          </CustomButton>
        </span>
      </Tooltip>

      <Tooltip title="Limpiar selección actual">
        <span>
          <CustomButton
            variant="warning"
            startIcon={<ClearIcon />}
            onClick={onClearSelection}
            disabled={disableClear}
            sx={{ mr: 2 }}
          >
            Limpiar selección
          </CustomButton>
        </span>
      </Tooltip>

      <Tooltip
        title={
          excelLoading || isExporting
            ? 'Generando archivo...'
            : 'Exportar el detalle filtrado completo a Excel'
        }
      >
        <span>
          <CustomButton
            variant="base"
            startIcon={<CloudDownloadIcon />}
            onClick={onExportExcel}
            disabled={disableExcel}
            isLoading={excelLoading}
            sx={{ mr: 2 }}
          >
            Exportar XLSX
          </CustomButton>
        </span>
      </Tooltip>

      <Tooltip
        title={
          pdfLoading || isExporting
            ? 'Generando archivo...'
            : 'Generar reporte PDF con todos los resultados filtrados'
        }
      >
        <span>
          <CustomButton
            variant="base"
            startIcon={<PictureAsPdfIcon />}
            onClick={onExportPdf}
            disabled={disablePdf}
            isLoading={pdfLoading}
            sx={{ mr: 2 }}
          >
            Exportar PDF
          </CustomButton>
        </span>
      </Tooltip>

      <Tooltip title={sendTooltip}>
        <span>
          <CustomButton
            variant="danger"
            startIcon={<OutgoingMailIcon />}
            onClick={onSendNotifications}
            disabled={disableSend}
          >
            Enviar notificación de mora
          </CustomButton>
        </span>
      </Tooltip>
    </HorizontalForm>
  );
};

export default DebtDetailActionsBar;
